// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2lWLt","errors":"Errors_errors__28lQ8"};